import React, { useEffect, useState } from 'react';
import { formatPhoneNumber } from 'react-phone-number-input';

import FormTitle from 'components/PageLayout/FormTitle';
import LoaderOverlay from 'components/PageLayout/LoaderOverlay';
import AuthCodeInput from 'components/curo-components/common/AuthCodeInput';
import { getContactInformationData } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { IDefaultStepProps } from 'pages/CuroPages/types';
import { sendVerificationCode, verifyCode } from 'thunks';
import styled from 'types/AppTheme';

const PAGE_TITLE = 'Sign In';

const VerifyCodeDescriptionWrapper = styled.p`
  display: flex;
  flex-direction: column;

  strong {
    font-weight: $boldFontWeight;
  }
`;

const SignInStep = ({ onStepComplete }: IDefaultStepProps) => {
  const [isCodeSent, setIsCodeSent] = useState<boolean>(false);
  const { borrowerPhone } = useAppSelector(getContactInformationData);
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const formattedPhoneNumber = formatPhoneNumber(borrowerPhone);

  const handleSendVerificationCode = async () => {
    await dispatchWithUnwrap(sendVerificationCode(borrowerPhone));
    setIsCodeSent(true);
  };

  useEffect(() => {
    handleSendVerificationCode();
  }, []);

  const handleVerifyCode = async (code: string) => {
    await dispatchWithUnwrap(verifyCode(code));
    onStepComplete();
  };

  const handleResendCode = async () => {
    await dispatchWithUnwrap(sendVerificationCode(borrowerPhone));
  };

  if (!isCodeSent) {
    <LoaderOverlay />;
  }

  return (
    <>
      <FormTitle
        title={PAGE_TITLE}
        subTitle={
          <VerifyCodeDescriptionWrapper>
            <span>
              We've sent a 6-digit verification code to <strong>{formattedPhoneNumber}</strong>.
            </span>
            <span>
              Once you receive the verification code, enter it here to confirm your identity.
            </span>
          </VerifyCodeDescriptionWrapper>
        }
      />
      <AuthCodeInput
        handleResendCode={handleResendCode}
        handleVerifyCode={handleVerifyCode}
        buttonTitle="Continue"
      />
    </>
  );
};

export default SignInStep;
